module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10"
  }, [_vm._l((_vm.uzenetek), function(uzenet, i) {
    return _c('div', {
      staticClass: "message-row",
      class: {
        admin: uzenet.Felhasznalotol == 0
      }
    }, [_c('div', {
      staticClass: "photo"
    }, [(uzenet.Felhasznalotol == 1) ? _c('img', {
      attrs: {
        "src": 'data:image/png;base64,' + _vm.$root.user.jpegphoto,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (uzenet.Felhasznalotol == 0) ? _c('img', {
      attrs: {
        "src": "assets/img/admin-profile.png",
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v("\n            " + _vm._s(uzenet.Idopont) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(uzenet.Uzenet)
      }
    })])
  }), _vm._v(" "), (!_vm.ujUzenet) ? _c('div', {
    staticClass: "info-box warning",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Figyelem!")]), _vm._v(" Új üzenet írása csak adminisztrátori válasz után lehetséges.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.ujUzenet) ? _c('div', {
    staticClass: "message-row"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": 'data:image/png;base64,' + _vm.$root.user.jpegphoto,
      "alt": ""
    }
  })]), _vm._v(" "), _c('textareabox', {
    attrs: {
      "errors": _vm.errors,
      "placeholder": "Kérjük írja le reklamációját...",
      "cstyle": "min-height: 100px",
      "iconclass": "fa fa-pencil",
      "autogrow": true,
      "maxlength": "1000",
      "id": "Uzenet",
      "label": "",
      "name": "Uzenet"
    },
    model: {
      value: (_vm.form.Uzenet),
      callback: function($$v) {
        _vm.form.Uzenet = $$v
      },
      expression: "form.Uzenet"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Reklamáció elküldése")])], 1) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fill_info != ''),
      expression: "fill_info != ''"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Rendszeres szociális támogatás és költségtérítés mérséklés reklamáció")]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Rendszeres szociális támogatás és költségtérítés mérséklés reklamáció")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70d4f3be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/rendszeres_szocialis_reklamacio.vue
// module id = 386
// module chunks = 0